<mat-card class="wrap_text">
  <mat-card-header>
    <mat-card-title class="card">
      <div class="card--title">
        <local-seo-source-name-icon
          [iconUrl]="data?.sourceIcon"
          [iconSize]="24"
          [name]="data?.name"
        ></local-seo-source-name-icon>
        <a *ngIf="data?.listingUrl" [href]="data?.listingUrl" target="_blank">
          {{ data?.name }}
          <mat-icon inline="true">open_in_new</mat-icon>
        </a>
        <div *ngIf="!data?.listingUrl">
          {{ data?.name }}
        </div>
      </div>
      <button (click)="closed.emit()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    @if (data?.account?.connectionId || (data?.sourceId === AppleSourceID && data?.account?.username)) {
      <local-seo-listing-sidebar-accounts
        [sourceId]="data?.sourceId"
        [sourceName]="data?.name"
        [listingUrl]="data?.listingUrl"
        [account]="data?.account"
        [additionalAccounts]="data?.additionalAccounts"
      ></local-seo-listing-sidebar-accounts>
      <mat-divider></mat-divider>
    }

    <local-seo-listing-sidebar-accuracy
      [accuracy]="data?.accuracy"
      [sourceSupportsListings]="data?.sourceHasReporting"
      [isSyncingEnabled]="data?.isSyncingEnabled"
      [syncStatus]="data?.syncStatus"
      [sourceId]="data.sourceId"
      [sourceName]="data.name"
      [isListingVerified]="data.isListingVerified"
      (markListingAccurate)="markListingAccurateEvent($event)"
    >
    </local-seo-listing-sidebar-accuracy>

    @if (data?.listingUrl || data.provider === DirectProvider || data.locked) {
      <mat-divider></mat-divider>
      <local-seo-listing-sidebar-actions
        [source]="data"
        [loading$$]="loadingChanges$$"
        (upgrade)="upgrade.emit()"
      ></local-seo-listing-sidebar-actions>
    }

    @if (canShowInfoModal(data?.sourceId)) {
      <a (click)="openSyncInfoModal()">
        {{ 'LISTING_SYNC.SOURCE_MENU.SYNCING_INFO_LINK' | translate: { source: data?.name } }}
      </a>
    }

    @if (data?.errorMessages?.length > 0) {
      <mat-divider></mat-divider>
      <local-seo-listing-sidebar-errors
        [errors]="data?.errorMessages"
        [sourceName]="data?.name"
        [sourceId]="data?.sourceId"
        [canForceSync]="canForceSync(data)"
      ></local-seo-listing-sidebar-errors>
    }

    @if (data.ecosystemSources?.length > 0) {
      <mat-divider></mat-divider>
      <div class="section-title">
        <div>{{ 'LISTING_SYNC.COLUMN_HEADERS.NETWORK_ECOSYSTEM' | translate }}</div>
        <mat-icon
          [glxyTooltip]="'LISTING_SYNC.COLUMN_HEADERS.NETWORK_ECOSYSTEM_TOOLTIP' | translate"
          [highContrast]="false"
        >
          info_outline
        </mat-icon>
      </div>
      @for (source of data.ecosystemSources; track source) {
        <div class="ecosystem">
          <local-seo-source-name-icon
            [iconUrl]="source?.icon"
            [iconSize]="20"
            [name]="source?.name"
            [shadow]="true"
          ></local-seo-source-name-icon>
          <p>{{ source?.name }}</p>
        </div>
      }
    }
  </mat-card-content>
</mat-card>
